
import {
  IonContent,
  IonPage,
  IonItem,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonIcon,
  IonSkeletonText,
  IonRow,
  IonCardContent,
} from '@ionic/react';
import { addCircleOutline, bagAddOutline, calendarOutline, extensionPuzzleOutline, location, shapesOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Red from '../../assets/Red.svg';
import axios from '../../axios';
import Header from '../../components/Header';
import NoRecords from '../../components/NoRecords';
import ScanButton from '../../components/ScanButton';
import { AppContext } from '../../providers/AppContext';

const HomeProject: React.FC = () => {
  const isMounted = useRef(true);
  const { t } = useTranslation();

  const [highlights, setHighlights] = useState([]);
  const [loader, setLoader] = useState(false);

  const { state } = useContext(AppContext);


  const getData = async () => {
    isMounted.current = true; // Set isMounted to true
    const url = '/method/preflet_asset.api.get_assigned_projects'
    const config: any = {
      method: 'get',
      url,
      headers: {
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    };
    try {
      setLoader(true);
      const res = await axios(config)
      if (isMounted.current)
        setHighlights(res.data.message);
    } catch (error: any) {
      console.log(error);
    } finally {
      if (isMounted.current)
        setLoader(false);
    }
  };

  useEffect(() => {
    getData();
    // Cleanup function
    return () => {
      isMounted.current = false; // Mark the component as unmounted when it's being cleaned up
      // You can also cancel any subscriptions or clean up other resources here
    };
  }, []);

  return (
    <IonPage>
      <Header enableBackButton="" title="" />
      <IonContent>

        {/* ── Hero Banner ── */}
        <div style={{
          background: 'linear-gradient(135deg, #1d508d 0%, #0f3460 100%)',
          padding: '16px 16px 16px',
          position: 'relative',
          overflow: 'hidden',
        }}>
          <div style={{ position: 'absolute', top: -30, right: -30, width: 120, height: 120, borderRadius: '50%', background: 'rgba(255,255,255,0.06)' }} />
          <div style={{ position: 'absolute', bottom: -20, left: -20, width: 80, height: 80, borderRadius: '50%', background: 'rgba(255,255,255,0.04)' }} />
          <p style={{ margin: 0, fontSize: 11, fontWeight: 600, color: 'rgba(255,255,255,0.6)', letterSpacing: '0.12em', textTransform: 'uppercase', position: 'relative', zIndex: 1, marginBottom: '1rem' }}>
            {t('Project.projects')}
          </p>
          {/* <h1 style={{ margin: '3px 0 12px', fontSize: 22, fontWeight: 800, color: '#fff', lineHeight: 1.15, position: 'relative', zIndex: 1 }}>
            Projects
          </h1> */}

          {/* ── Quick Action Buttons (inside banner) ── */}
          <div style={{ display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 4, position: 'relative', zIndex: 1, WebkitOverflowScrolling: 'touch' as any }}>
            {!!state.permissions.project_create && (
              <Link to="/create-project" style={{ textDecoration: 'none' }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                  background: '#fff',
                  borderRadius: 14,
                  padding: '10px 16px',
                  boxShadow: '0 4px 16px rgba(29,80,141,0.15)',
                  border: '1.5px solid rgba(29,80,141,0.1)',
                  cursor: 'pointer',
                }}>
                  <IonIcon src={bagAddOutline} style={{ fontSize: 18, color: '#1d508d' }} />
                  <span style={{ fontSize: 13, fontWeight: 700, color: '#1d508d', whiteSpace: 'nowrap' }}>
                    {t('Project.createProject')}
                  </span>
                </div>
              </Link>
            )}

            {!!state.permissions.project_create && (
              <Link to="/create-task" style={{ textDecoration: 'none' }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                  background: '#fff',
                  borderRadius: 14,
                  padding: '10px 16px',
                  boxShadow: '0 4px 16px rgba(29,80,141,0.15)',
                  border: '1.5px solid rgba(29,80,141,0.1)',
                  cursor: 'pointer',
                }}>
                  <IonIcon src={addCircleOutline} style={{ fontSize: 18, color: '#1d508d' }} />
                  <span style={{ fontSize: 13, fontWeight: 700, color: '#1d508d', whiteSpace: 'nowrap' }}>
                    {t('Project.createTask')}
                  </span>
                </div>
              </Link>
            )}
            <Link to="/view-all-task" style={{ textDecoration: 'none' }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                background: '#fff',
                borderRadius: 14,
                padding: '10px 16px',
                boxShadow: '0 4px 16px rgba(29,80,141,0.15)',
                border: '1.5px solid rgba(29,80,141,0.1)',
                cursor: 'pointer',
              }}>
                <IonIcon src={extensionPuzzleOutline} style={{ fontSize: 18, color: '#1d508d' }} />
                <span style={{ fontSize: 13, fontWeight: 700, color: '#1d508d', whiteSpace: 'nowrap' }}>
                  {t('Project.viewTasks')}
                </span>
              </div>
            </Link>
          </div>{/* end buttons row */}
        </div>{/* end hero banner */}

        {/* ── Section Header ── */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 16px 8px' }}>
          <p style={{ margin: 0, fontSize: 16, fontWeight: 800, color: '#1d508d' }}>{t('Project.projects')}</p>
          <Link to="/project-list" style={{ textDecoration: 'none' }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: '#1d508d', borderBottom: '1.5px solid rgba(29,80,141,0.3)' }}>
              {t('Project.viewAll')}
            </span>
          </Link>
        </div>

        {/* ── Skeleton Loaders ── */}
        {loader && [1, 2, 3, 4].map((el) => (
          <div key={el} style={{ margin: '0 16px 12px', background: '#fff', borderRadius: 16, padding: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
            <IonSkeletonText animated style={{ width: '60%', height: 16, borderRadius: 8 }} />
            <IonSkeletonText animated style={{ width: '40%', height: 12, marginTop: 8, borderRadius: 8 }} />
            <IonSkeletonText animated style={{ width: '30%', height: 12, marginTop: 6, borderRadius: 8 }} />
          </div>
        ))}

        {/* ── Project Cards ── */}
        <div style={{ padding: '0 16px' }}>
          {highlights?.map((element: any, key: number) => {
            const isOpen = element.status === 'Open';
            return (
              <Link
                key={key}
                to={{ pathname: '/view-project', state: element.name }}
                style={{ textDecoration: 'none' }}
              >
                <div style={{
                  background: '#fff',
                  borderRadius: 18,
                  padding: '16px',
                  marginBottom: 12,
                  boxShadow: '0 3px 16px rgba(0,0,0,0.07)',
                  border: '1.5px solid rgba(29,80,141,0.07)',
                  cursor: 'pointer',
                }}>
                  {/* Project name + status badge */}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                    <p style={{ margin: 0, fontSize: 15, fontWeight: 700, color: '#1d2d44', flex: 1 }}>
                      {element.project_name}
                    </p>
                    <span style={{
                      flexShrink: 0,
                      fontSize: 11,
                      fontWeight: 700,
                      padding: '3px 10px',
                      borderRadius: 20,
                      background: isOpen ? 'rgba(253,118,137,0.12)' : 'rgba(22,201,141,0.12)',
                      color: isOpen ? '#e03c5a' : '#16a87d',
                      border: `1px solid ${isOpen ? 'rgba(253,118,137,0.3)' : 'rgba(22,201,141,0.3)'}`,
                    }}>
                      {t(`Project.Status.${element.status}`)}
                    </span>
                  </div>

                  {/* Location */}
                  {element.location && (
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: 8, gap: 4 }}>
                      <IonIcon src={location} style={{ fontSize: 13, color: '#888' }} />
                      <span style={{ fontSize: 12, color: '#666' }}>{element.location}</span>
                    </div>
                  )}

                  {/* Dates */}
                  {(element.expected_start_date || element.expected_end_date) && (
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: 8, gap: 6 }}>
                      <IonIcon src={calendarOutline} style={{ fontSize: 13, color: '#888' }} />
                      <span style={{ fontSize: 12, color: '#666' }}>
                        {element.expected_start_date && `${t('Project.Start')}: ${element.expected_start_date}`}
                        {element.expected_start_date && element.expected_end_date && '  →  '}
                        {element.expected_end_date && `${t('Project.End')}: ${element.expected_end_date}`}
                      </span>
                    </div>
                  )}

                  {/* Tasks count chip */}
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: 10, gap: 6 }}>
                    <IonIcon src={shapesOutline} style={{ fontSize: 13, color: '#1d508d' }} />
                    <span style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: '#1d508d',
                      background: 'rgba(29,80,141,0.08)',
                      padding: '2px 10px',
                      borderRadius: 20,
                    }}>
                      {element.tasks} {t('Project.Task')}
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}

          {highlights.length > 0 && (
            <a
              href="/project-list"
              style={{ display: 'block', textAlign: 'center', margin: '8px 0 24px', fontSize: 13, fontWeight: 600, color: '#1d508d', textDecoration: 'none', borderBottom: '1.5px solid rgba(29,80,141,0.3)', width: 'fit-content', marginInline: 'auto' }}
            >
              {t('Utils.viewAll')}
            </a>
          )}
        </div>

        {/* ── Empty State ── */}
        {!loader && highlights.length === 0 && (
          <IonRow>
            <NoRecords width="30%" smallText={true} />
          </IonRow>
        )}

        <ScanButton isAssetPage={false} />
      </IonContent>
    </IonPage>
  );
};

export default HomeProject;
